const guiColors = {
    "motion-primary": "#e8ae68",
    "motion-primary-transparent": "#e8ae68e6",
    "motion-tertiary": "#d69340",

    "looks-secondary": "#e8ae68",
    "looks-transparent": "#d69a5159",
    "looks-light-transparent": "#d69a5126",
    "looks-secondary-dark": "#dfa45c",

    "extensions-primary": "#f2b161",
    "extensions-tertiary": "#e88a17",
    "extensions-transparent": "#e8ae6859",
    "extensions-light": "#ffddb3",

    "drop-highlight": "#ffddb3",
};

const blockColors = {
    checkboxActiveBackground: "#e8ae68",
    checkboxActiveBorder: "#d69340",
};

export { guiColors, blockColors };
